var states = [
    {
        "label": "Aguascalientes",
        "val": "AS"
    },
    {
        "label": "Baja California",
        "val": "BC"
    },
    {
        "label": "Baja California Sur",
        "val": "BS"
    },
    {
        "label": "Campeche",
        "val": "CM"
    },
    {
        "label": "Chiapas",
        "val": "CS"
    },
    {
        "label": "Chihuahua",
        "val": "CH"
    },
    {
        "label": "Ciudad de México",
        "val": "DF"
    },
    {
        "label": "Coahuila",
        "val": "CO"
    },
    {
        "label": "Colima",
        "val": "CL"
    },
    {
        "label": "Durango",
        "val": "DG"
    },
    {
        "label": "Guanajuato",
        "val": "GT"
    },
    {
        "label": "Guerrero",
        "val": "GR"
    },
    {
        "label": "Hidalgo",
        "val": "HG"
    },
    {
        "label": "Jalisco",
        "val": "JA"
    },
    {
        "label": "México",
        "val": "MX"
    },
    {
        "label": "Michoacán",
        "val": "MI"
    },
    {
        "label": "Morelos",
        "val": "MR"
    },
    {
        "label": "Nayarit",
        "val": "NA"
    },
    {
        "label": "Nuevo León",
        "val": "NL"
    },
    {
        "label": "Oaxaca",
        "val": "OA"
    },
    {
        "label": "Puebla",
        "val": "PU"
    },
    {
        "label": "Querétaro",
        "val": "QT",
        "short": "Qro."
    },
    {
        "label": "Quintana Roo",
        "val": "QR"
    },
    {
        "label": "San Luis Potosí",
        "val": "SL"
    },
    {
        "label": "Sinaloa",
        "val": "SI"
    },
    {
        "label": "Sonora",
        "val": "SO"
    },
    {
        "label": "Tabasco",
        "val": "TB"
    },
    {
        "label": "Tamaulipas",
        "val": "TM"
    },
    {
        "label": "Tlaxcala",
        "val": "TL"
    },
    {
        "label": "Veracruz",
        "val": "VZ"
    },
    {
        "label": "Yucatán",
        "val": "YU"
    },
    {
        "label": "Zacatecas",
        "val": "ZA"
    }
]

module.exports = states;